export const DEFAULT_EXPIRE_DAYS = 365; // 1 year
export const REFRESH_TOKEN_EXPIRE_DAYS = 30; // Registered users: matches the refresh-token lifetime pm_ums gives at sign-in
export const GUEST_REFRESH_TOKEN_EXPIRE_DAYS = 365 * 500; // Guests: expire in 500 years to match with BE
